const parseAmount = (value) => {
  const parsed = parseFloat(value);
  return Number.isFinite(parsed) ? parsed : NaN;
};

// Transitional: medicareRebate is the legacy single-value field.
// Read fallback below can be removed once all specialist_profiles use medicareRebateMin/Max.
export const getMedicareRebateRange = (feeEntry) => {
  if (!feeEntry) return null;

  const hasMinField =
    feeEntry.medicareRebateMin !== undefined &&
    feeEntry.medicareRebateMin !== '';

  if (hasMinField) {
    const min = parseAmount(feeEntry.medicareRebateMin);
    const max =
      feeEntry.medicareRebateMax !== undefined &&
      feeEntry.medicareRebateMax !== ''
        ? parseAmount(feeEntry.medicareRebateMax)
        : min;
    return { min, max };
  }

  // Legacy fallback — remove when medicareRebate is dropped from Firestore.
  if (feeEntry.medicareRebate !== undefined && feeEntry.medicareRebate !== '') {
    const legacy = parseAmount(feeEntry.medicareRebate);
    return { min: legacy, max: legacy };
  }

  return null;
};

export const getGapFeeRange = (feeEntry) => {
  if (!feeEntry) return null;

  const total = parseAmount(feeEntry.total);
  const rebateRange = getMedicareRebateRange(feeEntry);

  if (
    !rebateRange ||
    Number.isNaN(total) ||
    Number.isNaN(rebateRange.min) ||
    Number.isNaN(rebateRange.max)
  ) {
    return null;
  }

  return {
    min: total - rebateRange.max,
    max: total - rebateRange.min,
  };
};

const formatAmount = (value) => value.toFixed(2);

export const formatFeeRange = (min, max) => {
  if (Number.isNaN(min) || Number.isNaN(max)) return '';

  if (min === max) {
    return `$${formatAmount(min)}`;
  }

  return `$${formatAmount(min)} – $${formatAmount(max)}`;
};

export const formatMedicareRebateDisplay = (feeEntry) => {
  const rebateRange = getMedicareRebateRange(feeEntry);
  if (!rebateRange) return '';
  return formatFeeRange(rebateRange.min, rebateRange.max);
};

export const formatGapFeeDisplay = (feeEntry) => {
  const gapRange = getGapFeeRange(feeEntry);
  if (!gapRange) return '';
  return formatFeeRange(gapRange.min, gapRange.max);
};

export const formatTotalFeeDisplay = (feeEntry) => {
  const total = parseAmount(feeEntry?.total);
  return formatFeeRange(total, total);
};
